import ReceiptCheckDTO from "@/models/ReceiptCheckDTO";
import TraderDealDTO from "@/models/TraderDealDTO";
import {helper} from "@/service/CommonHelper";

export function isPdfAttachment(file: string | null | undefined): boolean {
  return typeof file === 'string' && file.toLowerCase().endsWith('.pdf');
}

export function findReceiptCheck(deal: TraderDealDTO, attachmentId: number): ReceiptCheckDTO | null {
  if (!Array.isArray(deal.receiptChecks)) {
    return null;
  }

  return deal.receiptChecks.find((item) => item.attachmentId === attachmentId) ?? null;
}

export function upsertReceiptCheck(deal: TraderDealDTO, check: ReceiptCheckDTO): void {
  if (!Array.isArray(deal.receiptChecks)) {
    deal.receiptChecks = [];
  }

  const index = deal.receiptChecks.findIndex((item) => item.attachmentId === check.attachmentId);
  if (index === -1) {
    deal.receiptChecks.push(check);
    return;
  }

  deal.receiptChecks.splice(index, 1, check);
}

function receiptVerdictLabel(verdict: string): string {
  return helper.trans(`receipt_check.verdict.${verdict}`, {}, verdict);
}

export function receiptVerdict(deal: TraderDealDTO, attachmentId: number): string {
  const check = findReceiptCheck(deal, attachmentId);
  return check ? receiptVerdictLabel(check.verdict) : '';
}

export function receiptCheckKey(dealId: string, attachmentId: number): string {
  return `${dealId}:${attachmentId}`;
}
